import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD9BUZcagD2g_JBaEgRvMh-qur8ZfVrZDI",
  authDomain: "iprog-project-c443f.firebaseapp.com",
  projectId: "iprog-project-c443f",
  storageBucket: "iprog-project-c443f.firebasestorage.app",
  messagingSenderId: "595324769234",
  appId: "1:595324769234:web:ace2f4dbe9a15143506e0b",
  measurementId: "G-XR96390FET",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
